"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var SitesApi = /** @class */ (function (_super) {
    __extends(SitesApi, _super);
    function SitesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Use this endpoint to check whether the site\'s email from address has been successfully verified
     * Check the status of the site\'s from email address verification
     */
    SitesApi.prototype.actionCheckEmailFromAddressVerificationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling actionCheckEmailFromAddressVerification.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/sites/{siteId}/check-email-from-address-verification".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SiteEmailFromAddressVerificationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to check whether the site\'s email from address has been successfully verified
     * Check the status of the site\'s from email address verification
     */
    SitesApi.prototype.actionCheckEmailFromAddressVerification = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionCheckEmailFromAddressVerificationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to generate an Opera FIAS support user and email the configuration to support@try.be.
     * Create an Opera FIAS user
     */
    SitesApi.prototype.createOperaFiasUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling createOperaFiasUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/sites/{siteId}/opera-fias-user".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Use this endpoint to generate an Opera FIAS support user and email the configuration to support@try.be.
     * Create an Opera FIAS user
     */
    SitesApi.prototype.createOperaFiasUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createOperaFiasUserRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve the appointment enquiry settings for a site
     * Retrieve a site\'s appointment enquiry settings
     */
    SitesApi.prototype.getAppointmentEnquirySettingsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling getAppointmentEnquirySettings.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/sites/{siteId}/appointment-enquiry-settings".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowAppointmentEnquirySettingsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve the appointment enquiry settings for a site
     * Retrieve a site\'s appointment enquiry settings
     */
    SitesApi.prototype.getAppointmentEnquirySettings = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAppointmentEnquirySettingsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve the service charge settings for a site
     * Retrieve a site\'s service charge settings
     */
    SitesApi.prototype.getServiceChargeSettingsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling getServiceChargeSettings.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/sites/{siteId}/service-charge-settings".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowServiceChargeSettingsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve the service charge settings for a site
     * Retrieve a site\'s service charge settings
     */
    SitesApi.prototype.getServiceChargeSettings = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getServiceChargeSettingsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a `Site`\'s categories.
     * Get all categories for a site
     */
    SitesApi.prototype.getSiteCategoriesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling getSiteCategories.');
                        }
                        queryParameters = {};
                        if (requestParameters.voucherApplicable !== undefined) {
                            queryParameters['voucher_applicable'] = requestParameters.voucherApplicable;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/sites/{siteId}/categories".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowSiteCategoriesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a `Site`\'s categories.
     * Get all categories for a site
     */
    SitesApi.prototype.getSiteCategories = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSiteCategoriesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a `Site`\'s logo.  If the `Site` hasn\'t provided a logo, `data` will be `null`.
     * Show a Site\'s logo
     */
    SitesApi.prototype.getSiteLogoRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling getSiteLogo.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/sites/{siteId}/logo".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowSiteLogoFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a `Site`\'s logo.  If the `Site` hasn\'t provided a logo, `data` will be `null`.
     * Show a Site\'s logo
     */
    SitesApi.prototype.getSiteLogo = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSiteLogoRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint retrieves the SMS Notification Settings for the given site.
     * Show SMS Notification Settings
     */
    SitesApi.prototype.getSmsNotificationSettingsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling getSmsNotificationSettings.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/sites/{siteId}/sms-settings".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowSmsNotificationSettingsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint retrieves the SMS Notification Settings for the given site.
     * Show SMS Notification Settings
     */
    SitesApi.prototype.getSmsNotificationSettings = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSmsNotificationSettingsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint returns a list of the locales that are supported by the site.  When a `Customer` has a preferred locale, if the locale is included in the site\'s supported comms locales, then any email communication will be sent in that preferred locale.  The locales must be included in the platform\'s supported locales, which can be retrieved using the [`listMetaSupportedLocales`](/endpoints/Meta#listMetaSupportedLocales) endpoint.
     * Get supported comms locales
     */
    SitesApi.prototype.getSupportedCommsLocalesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling getSupportedCommsLocales.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/sites/{siteId}/supported-comms-locales".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListSupportedCommsLocalesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint returns a list of the locales that are supported by the site.  When a `Customer` has a preferred locale, if the locale is included in the site\'s supported comms locales, then any email communication will be sent in that preferred locale.  The locales must be included in the platform\'s supported locales, which can be retrieved using the [`listMetaSupportedLocales`](/endpoints/Meta#listMetaSupportedLocales) endpoint.
     * Get supported comms locales
     */
    SitesApi.prototype.getSupportedCommsLocales = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSupportedCommsLocalesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to update the appointment enquiry settings for a site
     * Update a site\'s appointment enquiry settings
     */
    SitesApi.prototype.updateAppointmentEnquirySettingsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling updateAppointmentEnquirySettings.');
                        }
                        if (requestParameters.updateAppointmentEnquirySettings === null || requestParameters.updateAppointmentEnquirySettings === undefined) {
                            throw new runtime.RequiredError('updateAppointmentEnquirySettings', 'Required parameter requestParameters.updateAppointmentEnquirySettings was null or undefined when calling updateAppointmentEnquirySettings.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/sites/{siteId}/appointment-enquiry-settings".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateAppointmentEnquirySettingsToJSON(requestParameters.updateAppointmentEnquirySettings),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowAppointmentEnquirySettingsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to update the appointment enquiry settings for a site
     * Update a site\'s appointment enquiry settings
     */
    SitesApi.prototype.updateAppointmentEnquirySettings = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateAppointmentEnquirySettingsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to update the service charge settings for a site
     * Update a site\'s service charge settings
     */
    SitesApi.prototype.updateServiceChargeSettingsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling updateServiceChargeSettings.');
                        }
                        if (requestParameters.updateServiceChargeSettings === null || requestParameters.updateServiceChargeSettings === undefined) {
                            throw new runtime.RequiredError('updateServiceChargeSettings', 'Required parameter requestParameters.updateServiceChargeSettings was null or undefined when calling updateServiceChargeSettings.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/sites/{siteId}/service-charge-settings".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateServiceChargeSettingsToJSON(requestParameters.updateServiceChargeSettings),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowServiceChargeSettingsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to update the service charge settings for a site
     * Update a site\'s service charge settings
     */
    SitesApi.prototype.updateServiceChargeSettings = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateServiceChargeSettingsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to update an existing `Site`.
     * Update a Site
     */
    SitesApi.prototype.updateSiteRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling updateSite.');
                        }
                        if (requestParameters.updateSite === null || requestParameters.updateSite === undefined) {
                            throw new runtime.RequiredError('updateSite', 'Required parameter requestParameters.updateSite was null or undefined when calling updateSite.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/sites/{siteId}".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateSiteToJSON(requestParameters.updateSite),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SiteResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to update an existing `Site`.
     * Update a Site
     */
    SitesApi.prototype.updateSite = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSiteRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint updates the SMS Notification Settings for the given site.
     * Update SMS Notification Settings
     */
    SitesApi.prototype.updateSmsNotificationSettingsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling updateSmsNotificationSettings.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/sites/{siteId}/sms-settings".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateSmsNotificationSettingsToJSON(requestParameters.updateSmsNotificationSettings),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowSmsNotificationSettingsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint updates the SMS Notification Settings for the given site.
     * Update SMS Notification Settings
     */
    SitesApi.prototype.updateSmsNotificationSettings = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSmsNotificationSettingsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint allows you to update the list of locales that are supported by the site.  When a `Customer` has a preferred locale, if the locale is included in the site\'s supported comms locales, then any email communication will be sent in that preferred locale.  The locales must be included in the platform\'s supported locales, which can be retrieved using the [`listMetaSupportedLocales`](/endpoints/Meta#listMetaSupportedLocales) endpoint.
     * Update supported comms locales
     */
    SitesApi.prototype.updateSupportedCommsLocalesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling updateSupportedCommsLocales.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/sites/{siteId}/supported-comms-locales".replace("{" + "siteId" + "}", encodeURIComponent(String(requestParameters.siteId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateSupportedCommsLocalesToJSON(requestParameters.updateSupportedCommsLocales),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListSupportedCommsLocalesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint allows you to update the list of locales that are supported by the site.  When a `Customer` has a preferred locale, if the locale is included in the site\'s supported comms locales, then any email communication will be sent in that preferred locale.  The locales must be included in the platform\'s supported locales, which can be retrieved using the [`listMetaSupportedLocales`](/endpoints/Meta#listMetaSupportedLocales) endpoint.
     * Update supported comms locales
     */
    SitesApi.prototype.updateSupportedCommsLocales = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSupportedCommsLocalesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SitesApi;
}(runtime.BaseAPI));
exports.SitesApi = SitesApi;
